import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { CohortAffinityUsers } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/CohortAffinityUsers';
import { AboutYourCohortCards } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/aboutYourCohortUsersCards/AboutYourCohortCards';
import { ContributingFactorsCards } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributingFactorsCards';
import { FlexSpacer } from 'ui/flexSpacer';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import { EngagementOverviewCard } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/aboutYourCohortUsersCards/EngagementOverviewCard';
import { UserMovementCard } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/aboutYourCohortUsersCards/UserMovementCard';
import { StyledDivider } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import { ViewSegmentation } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/ViewSegmentation';
import { MODERNIZED_SEGMENTATION_PAGE } from 'modules/segmentation/constants';
import { createSearchQueryWithSingleRequirement } from 'modules/segmentation/navigation/utils/createSearchQueryWithSingleRequirement';
import { ClientDataType, FieldType, NumericComparator } from 'modules/queryBuilder/types';
import { ITBLDS_BA_PREFIX } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { BrandAffinityLevel } from 'modules/domains';
import { FC } from 'react';

export const createSegmentationSearchQuery = (affinity: BrandAffinityLevel) =>
  createSearchQueryWithSingleRequirement(ClientDataType.User, [
    {
      dataType: ClientDataType.User,
      field: ITBLDS_BA_PREFIX,
      fieldType: FieldType.STRING,
      comparatorType: NumericComparator.EQUALS,
      value: affinity,
    },
  ]);

export interface AffinityContentProps {
  affinityLevel: BrandAffinityLevel;
}
export const AffinityContent: FC<AffinityContentProps> = ({ affinityLevel }) => {
  const { selectedAffinityTab } = useCoreContext();
  const isModernSegmentationEnabled = useFeatureFlag(MODERNIZED_SEGMENTATION_PAGE);

  return (
    <>
      <FlexSpacer
        alignItems="center"
        data-test={`${selectedAffinityTab}-affinity-content`}
        justifyContent="space-between"
      >
        <CohortAffinityUsers />
        {isModernSegmentationEnabled ? (
          <ViewSegmentation searchQuery={createSegmentationSearchQuery(selectedAffinityTab)} />
        ) : null}
      </FlexSpacer>
      <StyledDivider />
      <AboutYourCohortCards>
        {affinityLevel !== BrandAffinityLevel.UNSCORED && <EngagementOverviewCard />}
        <UserMovementCard />
      </AboutYourCohortCards>
      <ContributingFactorsCards />
    </>
  );
};
